import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import FixedView from '../../components/FixedView'
import IntractionActionsList from '../../components/IntractionActionsList'
import importedIcons from '../../components/inputs/icons'
import StagesManager from '../../components/StagesManager'

export default class DriveStyle extends Component {

    state = {
        viewStyle: 'details'
    }


    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    closeFixedView = () => {
        this.viewView.hideView()
    }

    viewStyleShow = (view) => {
        if (view == 'mediumIcons' || view == 'details') {
            this.setState({ viewStyle: view })
            this.props.setStateProps("view", view)
        }
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.view = el} onClick={() => { this.viewView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('Style')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.viewView = el} nodeRef={this.view} xOffset={this.props.language == 'fa' ? 175 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'view'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    {/* <div className='mb-2'> */}
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('extraLargeIcons') }} data={{ title: "{{lang}}drives.Extra large icons", check2: this.state.viewStyle == 'extraLargeIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('largeIcons') }} data={{ title: "{{lang}}drives.Large icons", check2: this.state.viewStyle == 'largeIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('mediumIcons') }} data={{ title: "{{lang}}drives.Medium icons", check2: this.state.viewStyle == 'mediumIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('smallIcons') }} data={{ title: "{{lang}}drives.Small icons", check2: this.state.viewStyle == 'smallIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('list') }} data={{ title: "{{lang}}drives.List", check2: this.state.viewStyle == 'list' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('details') }} data={{ title: "{{lang}}drives.Details", check2: this.state.viewStyle == 'details' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('tiles') }} data={{ title: "{{lang}}drives.Tiles", check2: this.state.viewStyle == 'tiles' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                    {/* <IntractionActionsList onClick={() => { this.viewStyleShow('content') }} data={{ title: "{{lang}}drives.Content", check2: this.state.viewStyle == 'content' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} /> */}
                                </div>
                                {/* <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Compact view", icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => this.changePageSubMenu('Show')} data={{ title: "{{lang}}drives.Show", sub: true, icon: "/assets/icons/note/view/mode.svg" }} language={this.props.language} />
                                </div> */}
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'Show'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    <div className='pb-2'>
                                        <button className='flexc w-100 hover-gray p-2 br-10' onClick={this.lastPage}>
                                            <img width={18} src={importedIcons.arrowLeft} className='rtl-button' />
                                            <p className='font-size-13 weight-500 mld-3 main-c3 text-start'>{translate('drives.Show')}</p>
                                        </button>
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Navigation", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Details pane", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Preview pane", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Item check boxes", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.File name extentions", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Hidden items", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
